module.exports = __webpack_public_path__ + "static/media/ArchivedFolderWithFolder.56e380fd.svg";